import React from "react";
import { SearchClass as ContentSearch } from "../../Conteudos/SearchClass";

export function SearchClass(props) {
  return <ContentSearch {...props} tipo="olimpiada" />;
}
